import { useSelector } from 'react-redux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import * as creditAppSelectors from '@makemydeal/dr-dash-store/selectors/creditAppSelectors';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { HostEnvironment, hostUrlHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { C3BaseUrls } from '../constants';

const getC3BaseUrl = (environmentEnum: HostEnvironment) => {
    switch (environmentEnum) {
        case HostEnvironment.Local:
        case HostEnvironment.Dev:
        case HostEnvironment.Dev2:
            return C3BaseUrls.NonProd;
        case HostEnvironment.QA:
            return C3BaseUrls.PreProd;
        case HostEnvironment.UAT:
            return C3BaseUrls.PreProd;
        case HostEnvironment.Prod:
            return C3BaseUrls.Prod;
        default:
            return C3BaseUrls.PreProd;
    }
};

export const useOrderAgnosticILDPURL = () => {
    const commonOrgId = useSelector(offerSelectors.getCommonOrgId);
    const dealRefId = useSelector(offerSelectors.getDealRefId);
    const creditAppId = useSelector(creditAppSelectors.getCreditAppReferenceId);
    const partnerId = useSelector(dealerSelectors.getPartnerId);
    const partnerDealerId = useSelector(dealerSelectors.getPartnerDealerId);

    const environmentEnum = hostUrlHelper.getHostUrlEnvironment(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref());
    const agnosticILDPUrl = getC3BaseUrl(environmentEnum);

    const hasAllFieldsValueExists = commonOrgId && dealRefId && creditAppId && partnerId && partnerDealerId;

    if (hasAllFieldsValueExists) {
        const ildpAgnosticUrl = `${agnosticILDPUrl}/ildp/${commonOrgId}/${dealRefId}/${creditAppId}/${partnerId}/${partnerDealerId}`;
        return ildpAgnosticUrl;
    }

    return '';
};
